import moment from 'moment';

import * as filterHeaderTypes from '../../webcommon/header/filterheader/propTypes';

import { lastWorkingDay } from '../../common/helpermethods/HelperMethods';

export const columns = [
    {
        id: 'date',
        visible: true,
        minWidth: 200
    },
    {
        id: 'userName',
        visible: true,
        minWidth: 200
    },
    {
        id: 'id',
        visible: true,
        minWidth: 200
    }
];

export const mappings = [
    {
        title: 'Impact Analysis ID',
        id: 'id',
        type: 'string',
        draggable: false,
        hideable: true,
        sortable: true
    },
    {
        title: 'User Name',
        id: 'userName',
        type: 'string',
        draggable: false,
        hideable: true,
        sortable: true
    },
    {
        title: 'Date',
        id: 'date',
        type: 'string',
        draggable: false,
        hideable: true,
        sortable: true,
        renderCell: row => moment(row.value).format('DD MMM YYYY')
    }
];

export const filterDefinitions = [
    {
        id: 'runDate',
        title: 'EOD Date',
        type: filterHeaderTypes.filterTypes.date,
        defaultValue: { from: lastWorkingDay(), to: lastWorkingDay(), today: false },
        availableValues: undefined,
        availableValuesLocation: undefined,
        server: true,
        fixed: true,
        useValidation: true,
        hideAllButton: true,
        hideToday: true
    },
    {
        id: 'userName',
        title: 'User Name',
        type: filterHeaderTypes.filterTypes.string,
        defaultValue: [],
        availableValues: undefined,
        availableValuesLocation: undefined,
        server: true,
        fixed: true,
        wide: true,
        includeGroupTitle: false,
        radio: true
    }
];

export const defaultFilters = [
    {
        value: {
            from: lastWorkingDay(),
            to: lastWorkingDay(),
            today: false
        },
        definition: filterDefinitions.find(def => def.id === 'runDate')
    },
    {
        definition: filterDefinitions.find(def => def.id === 'userName'),
        value: ''
    }
];
